import { API } from '../config';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { ScrollArea } from '../components/ui/scroll-area';
import { ChevronLeft, Laptop, Smartphone, Tablet, LogOut, Shield, Wifi } from 'lucide-react';
import { toast } from 'sonner';


export default function DevicesPage() {
  const { getAuthHeaders } = useAuth();
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDevices = async () => { try { const res = await axios.get(`${API}/devices/me`, { headers: getAuthHeaders() }); setDevices(res.data); } catch { toast.error('Cihazlar yüklenemedi'); } finally { setLoading(false); } };
  useEffect(() => { fetchDevices(); }, []); // eslint-disable-line

  const handleLogoutDevice = async (deviceId) => { try { await axios.post(`${API}/devices/${deviceId}/logout`, {}, { headers: getAuthHeaders() }); toast.success('Cihaz oturumu kapatıldı'); fetchDevices(); } catch { toast.error('Başarısız'); } };
  const getDeviceIcon = (type) => { switch (type) { case 'mobile': return Smartphone; case 'tablet': return Tablet; default: return Laptop; } };
  const formatTime = (ts) => ts ? new Date(ts).toLocaleString('tr-TR') : '-';
  const statusLabels = { approved: 'Onaylı', pending: 'Bekliyor', disabled: 'Devre Dışı', rejected: 'Reddedildi' };

  return (
    <div className="min-h-dvh bg-background">
      <div className="sticky top-0 z-10 bg-card/95 backdrop-blur border-b border-border/70 px-4 py-3 flex items-center gap-3">
        <Button variant="ghost" size="icon" className="rounded-xl" onClick={() => navigate('/app')}><ChevronLeft className="w-5 h-5" /></Button>
        <Shield className="w-5 h-5 text-primary" />
        <h1 className="text-lg font-semibold font-display">Cihazlarım</h1>
      </div>
      <div className="max-w-lg mx-auto p-4">
        {loading ? (<div className="text-center py-12 text-muted-foreground text-sm">Yükleniyor...</div>) : devices.length === 0 ? (<div className="text-center py-12 text-muted-foreground text-sm">Cihaz bulunamadı</div>) : (
          <ScrollArea><p className="text-xs text-muted-foreground mb-3">{devices.length} cihaz hesabınıza bağlı</p>
            {devices.map(device => { const Icon = getDeviceIcon(device.device_type); return (
              <div key={device.id} className="bg-card rounded-xl border border-border/70 p-4 mb-3">
                <div className="flex items-start justify-between">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center"><Icon className="w-5 h-5 text-muted-foreground" /></div>
                    <div>
                      <p className="text-sm font-medium">{device.device_name}</p>
                      <p className="text-xs text-muted-foreground">{device.os} | {device.browser}</p>
                      <div className="flex items-center gap-2 mt-1">
                        <Badge variant={device.status === 'approved' ? 'default' : device.status === 'pending' ? 'secondary' : 'destructive'} className="text-[10px]">{statusLabels[device.status] || device.status}</Badge>
                        {device.active_sessions > 0 && <span className="text-[10px] text-green-500 flex items-center gap-0.5"><Wifi className="w-2.5 h-2.5" /> Aktif</span>}
                      </div>
                      <p className="text-[10px] text-muted-foreground mt-1">IP: {device.ip_last || 'Bilinmiyor'}</p>
                      <p className="text-[10px] text-muted-foreground">Son görülme: {formatTime(device.last_seen)}</p>
                    </div>
                  </div>
                  {device.active_sessions > 0 && (<Button variant="outline" size="sm" className="h-8 text-xs rounded-lg" onClick={() => handleLogoutDevice(device.id)}><LogOut className="w-3 h-3 mr-1" /> Çıkış</Button>)}
                </div>
              </div>
            ); })}
          </ScrollArea>
        )}
      </div>
    </div>
  );
}
